/**
 * Converts a multi-select string array filter to a boolean value for API calls.
 * Used for approval status filters where:
 * - ["true"] means approved (returns true)
 * - ["false"] means unapproved (returns false)
 * - empty, undefined, or both selected means no filter (returns undefined)
 */
export function approvalFilterToBoolean(values?: string[]): boolean | undefined {
  if (!values || values.length === 0 || values.length === 2) {
    return undefined;
  }

  return values[0] === 'true';
}
